import React, { useState, useEffect } from 'react';
import { getAccountHistory } from 'config/api';
import { formatDate } from 'utils/formatter';
import { convertDate } from 'utils/date';
import { useModal } from 'hooks/useModal';
import { userBrokerProps, IncomeGainItemProps } from 'pages/DividendDeposit';
import Icon from 'components/commons/icon/Icon';
import { GettingSbiAccountDataModal } from '../modal/GettingSbiAccountDataModal';

export type accountHistoryProps = {
  totalAssetHistories: {
    day: number;
    totalAssetAmount: number;
  }[];
  debtAssetHistories: {
    day: number;
    debtAmount: number;
  }[];
};

const GettingSbiAccountMessageInternal = ({
  accounts,
}: {
  accounts: userBrokerProps[];
}) => {
  const [accountHistories, setAccountHistories] = useState<
    accountHistoryProps[] | null
  >(null);

  const [isShowModal, { hideModal, showModal }] = useModal();

  useEffect(() => {
    (async () => {
      const accountHistories = await Promise.all(
        accounts.map(async account => {
          const ret_ = await getAccountHistory(account.account);
          const ret = {
            totalAssetHistories: ret_.TotalAssetHistories.map(item => {
              return {
                day: item.Day,
                totalAssetAmount: item.TotalAssetAmount,
              };
            }),
            debtAssetHistories: ret_.DebtAssetHistories.map(item => {
              return {
                day: item.Day,
                debtAmount: item.DebtAmount,
              };
            }),
          } as accountHistoryProps;

          return await ret;
        })
      );

      setAccountHistories(accountHistories);
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (accountHistories === null) return <></>;

  const toDay = formatDate(new Date(), 'yyyyMMdd');

  const day = new Date();
  day.setDate(day.getDate() - 1);
  const oneDayAgo = formatDate(day, 'yyyyMMdd');

  const isGettingSbiAccount = accountHistories.some(list => {
    if (list.totalAssetHistories.length === 0) return false;

    return list.totalAssetHistories.every(data => {
      return data.day === Number(toDay) || data.day === Number(oneDayAgo)
        ? true
        : false;
    });
  });

  return (
    <>
      {isGettingSbiAccount ? (
        <>
          <div className="px-4 pt-4">
            <div className="flex w-full px-5 py-2 rounded-lg text-sm bg-teal-75">
              <Icon
                name="reflesh"
                className="flex items-center h-5 text-teal-600 pr-2"
              />
              <div className="">SBI証券の情報を取得中です</div>
              <div
                className="ml-auto text-link cursor-pointer"
                onClick={showModal}>
                詳細を確認
              </div>
            </div>
          </div>
          <GettingSbiAccountDataModal
            {...{
              isShow: isShowModal,
              hide: hideModal,
            }}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export const GettingSbiAccountMessage = ({
  userBroker,
  incomeGainData,
}: {
  userBroker: userBrokerProps[];
  incomeGainData: IncomeGainItemProps[];
}) => {
  const sbiAccounts = userBroker.filter(list => list.brokerID === 'SBI');

  if (sbiAccounts.length === 0) return <></>;

  const from = convertDate(new Date());
  from.setDate(from.getDate() - 1);
  from.setHours(22, 0, 0);

  const to = convertDate(new Date());
  to.setHours(15, 0, 0);

  const targetAccounts = sbiAccounts.filter(account => {
    const updTime = new Date(account.updTime);

    const accountIncomeGainData = incomeGainData.filter(
      data => data.account === account.account
    );

    if (
      from.getTime() <= updTime.getTime() &&
      updTime.getTime() <= to.getTime() &&
      account.status === '000' &&
      accountIncomeGainData.length === 0
    )
      return true;
    return false;
  });

  return <GettingSbiAccountMessageInternal {...{ accounts: targetAccounts }} />;
};
